"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetProductsTerminalNode = void 0;
const react_1 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const get_products_terminal_node_query_1 = require("../gql/get-products-terminal-node.query");
const store_1 = require("../../../../store");
const useGetProductsTerminalNode = () => {
    const productTreeId = (0, store_1.useProductTreeId)();
    const [getProductsTerminalNode, { loading, error, data }] = (0, react_1.useLazyQuery)(get_products_terminal_node_query_1.GET_PRODUCTS_TERMINAL_NODE);
    const executeQuery = (productId) => {
        const variables = {
            sort: [{ productTreeNodeAncestorsCount: graphql_1.SortOrder.Asc }],
            filter: {
                id: { in: [productId] },
            },
            productTrees: [productTreeId],
        };
        return getProductsTerminalNode({ variables });
    };
    return {
        executeQuery,
        loading,
        error,
        data,
    };
};
exports.useGetProductsTerminalNode = useGetProductsTerminalNode;
